function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Tracks the user's current selection, and exposes it to the subtree using the
 * function-as-children pattern.
 */
var React = require("react");

var babelPluginFlowReactPropTypes_proptype_DOMRange = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMRange || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlight = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlight || require("react").PropTypes.any;

Object.defineProperty(module.exports, "babelPluginFlowReactPropTypes_proptype_TrackedSelection", require("react").PropTypes.shape({
    focusNode: require("react").PropTypes.any.isRequired,
    focusOffset: require("react").PropTypes.number.isRequired,
    proposedHighlight: babelPluginFlowReactPropTypes_proptype_DOMHighlight
}));

var SelectionTracker = function (_React$PureComponent) {
    _inherits(SelectionTracker, _React$PureComponent);

    function SelectionTracker() {
        var _temp, _this, _ret;

        _classCallCheck(this, SelectionTracker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            mouseState: "up",
            trackedSelection: null
        }, _this._handleSelectionChange = function () {
            _this._updateTrackedSelection(_this.props.buildHighlight);

            if (_this.state.mouseState === "down") {
                _this.setState({
                    mouseState: "down-and-selecting"
                });
            }
        }, _this._handleMouseDown = function () {
            _this.setState({ mouseState: "down" });
        }, _this._handleMouseUp = function () {
            _this.setState({ mouseState: "up" });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    SelectionTracker.prototype.componentDidMount = function componentDidMount() {
        this._updateListeners(false, this.props.enabled);
    };

    SelectionTracker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.buildHighlight !== nextProps.buildHighlight) {
            // The highlight-building function changed, so the
            // proposedHighlight we built with it might be different, or no
            // longer be valid. Update accordingly.
            this._updateTrackedSelection(nextProps.buildHighlight);
        }

        this._updateListeners(this.props.enabled, nextProps.enabled);
    };

    SelectionTracker.prototype.componentWillUnmount = function componentWillUnmount() {
        this._updateListeners(this.props.enabled, false);
    };

    SelectionTracker.prototype._updateListeners = function _updateListeners(wasListening, willListen) {
        if (!wasListening && willListen) {
            window.addEventListener("mousedown", this._handleMouseDown);
            window.addEventListener("mouseup", this._handleMouseUp);
            document.addEventListener("selectionchange", this._handleSelectionChange);
        } else if (wasListening && !willListen) {
            window.removeEventListener("mousedown", this._handleMouseDown);
            window.removeEventListener("mouseup", this._handleMouseUp);
            document.removeEventListener("selectionchange", this._handleSelectionChange);

            // Additionally, reset the state, to guard against errors where we
            // re-enter listening mode and have stale values stored.
            this.setState({
                mouseState: "up",
                trackedSelection: null
            });
        }
    };

    /**
     * Get the current selection focus and range, if present and non-collapsed.
     *
     * Otherwise, if there is no current selection or it's collapsed, return
     * null.
     */


    SelectionTracker.prototype._computeFocusAndRange = function _computeFocusAndRange() {
        var selection = document.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return null;
        }

        var range = selection.getRangeAt(0);
        if (range.collapsed) {
            return null;
        }

        // NOTE(mdr): The focus node is guaranteed to exist, because
        //     there's a range, but the Flow type annotations for
        //     Selection don't know that. Cast it ourselves.
        var focusNode = selection.focusNode;
        var focusOffset = selection.focusOffset;
        return { focusNode: focusNode, focusOffset: focusOffset, range: range };
    };

    /**
     * Compute the current TrackedSelection from the document state.
     */


    SelectionTracker.prototype._computeTrackedSelection = function _computeTrackedSelection(buildHighlight) {
        var focusAndRange = this._computeFocusAndRange();
        if (!focusAndRange) {
            return null;
        }

        var focusNode = focusAndRange.focusNode,
            focusOffset = focusAndRange.focusOffset,
            range = focusAndRange.range;

        var proposedHighlight = buildHighlight(range);
        if (!proposedHighlight) {
            return null;
        }

        return { focusNode: focusNode, focusOffset: focusOffset, proposedHighlight: proposedHighlight };
    };

    /**
     * Update the TrackedSelection to reflect the document state.
     */


    SelectionTracker.prototype._updateTrackedSelection = function _updateTrackedSelection(buildHighlight) {
        var trackedSelection = this._computeTrackedSelection(buildHighlight);
        this.setState({ trackedSelection: trackedSelection });
    };

    SelectionTracker.prototype.render = function render() {
        var _state = this.state,
            mouseState = _state.mouseState,
            trackedSelection = _state.trackedSelection;

        var userIsMouseSelecting = mouseState === "down-and-selecting";

        return this.props.children && React.createElement(
            "div",
            null,
            this.props.children(trackedSelection, userIsMouseSelecting)
        );
    };

    return SelectionTracker;
}(React.PureComponent);

SelectionTracker.propTypes = {
    buildHighlight: require("react").PropTypes.func.isRequired,
    children: require("react").PropTypes.func,
    enabled: require("react").PropTypes.bool.isRequired
};


module.exports = SelectionTracker;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/ui/selection-tracker.jsx
 ** module id = 349
 ** module chunks = 0 1
 **/